<template>
  <div class="amzshop-page">
    <!-- Header -->
    <div class="as-header">
      <div>
        <span class="header-eyebrow">Amazon</span>
        <h2 class="header-title">Amazon - Shopify Match</h2>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Total</span>
        <span class="kpi-value">{{ records.length }}</span>
        <span class="kpi-foot">registros</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Pendientes</span>
        <span class="kpi-value kpi-value--warning">{{ countPendientes }}</span>
        <span class="kpi-foot">sin resolver</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Correctos</span>
        <span class="kpi-value kpi-value--green">{{ countCorrectos }}</span>
        <span class="kpi-foot">mapeados</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Errores</span>
        <span class="kpi-value kpi-value--danger">{{ countErrores }}</span>
        <span class="kpi-foot">con problemas</span>
      </div>
    </div>

    <!-- Upload section -->
    <div class="section-card">
      <div class="section-card__header">
        <h3 class="section-card__title"><i class="fa-solid fa-upload"></i> Subir archivo</h3>
      </div>
      <div class="upload-row">
        <b-form-file
          v-model="csvSkuAmazon"
          placeholder="Selecciona CSV, XLSX o JSON..."
          drop-placeholder="Suelta aqui..."
          accept=".csv,.xlsx,.xls,.json"
          class="upload-input"
        />
        <button class="btn-as btn-as--primary" @click="procesarArchivo">
          <i class="fa-solid fa-gear"></i> Procesar
        </button>
        <button class="btn-as btn-as--warning" @click="subirImagenesJson">
          <i class="fa-solid fa-image"></i> Subir imagenes
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Registros</h3>
        <div class="list-card__filters">
          <div class="filter-pills">
            <button :class="['pill', { active: mostrarTipo === 'Todos' }]" @click="mostrarTipo = 'Todos'">Todos</button>
            <button :class="['pill pill--warning', { active: mostrarTipo === 'Pendientes' }]" @click="mostrarTipo = 'Pendientes'">Pendientes</button>
            <button :class="['pill pill--green', { active: mostrarTipo === 'Correctos' }]" @click="mostrarTipo = 'Correctos'">Correctos</button>
            <button :class="['pill pill--danger', { active: mostrarTipo === 'Error' }]" @click="mostrarTipo = 'Error'">Error</button>
          </div>
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input type="text" class="search-box__input" placeholder="Buscar SKU, EAN..." v-model="searchTerm" />
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="filteredRecords"
          :fields="columns"
          class="mb-0"
          hover
          sort-icon-left
          responsive
          show-empty
          empty-text="Sin registros"
          :tbody-tr-class="rowClass"
          thead-class="table-head"
        >
          <template #cell(skuAmazon)="data">
            <span class="cell-sku">{{ data.item.skuAmazon }}</span>
          </template>
          <template #cell(skuShopify)="data">
            <span class="cell-sku cell-sku--accent" v-if="data.item.skuShopify">{{ data.item.skuShopify }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>
          <template #cell(tituloAmazon)="data">
            <span class="cell-text" v-if="data.item.tituloAmazon">{{ data.item.tituloAmazon }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>
          <template #cell(tituloShopify)="data">
            <span class="cell-text" v-if="data.item.tituloShopify">{{ data.item.tituloShopify }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>
          <template #cell(estado)="data">
            <span :class="['estado-badge', data.item.estado === 1 ? 'estado-badge--ok' : data.item.estado === 2 ? 'estado-badge--error' : 'estado-badge--pending']">
              <i :class="data.item.estado === 1 ? 'fa-solid fa-check' : data.item.estado === 2 ? 'fa-solid fa-xmark' : 'fa-solid fa-clock'"></i>
            </span>
          </template>
          <template #cell(acciones)="data">
            <div class="cell-actions">
              <button class="action-btn action-btn--edit" @click="editLine(data.item)" title="Editar">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button v-if="data.item.estado === 0 || data.item.estado === 2" class="action-btn action-btn--ok" @click="changueEstado(data.item, 1)" title="Marcar correcto">
                <i class="fa-solid fa-thumbs-up"></i>
              </button>
              <button v-if="data.item.estado === 0 || data.item.estado === 1" class="action-btn action-btn--error" @click="changueEstado(data.item, 2)" title="Marcar error">
                <i class="fa-solid fa-thumbs-down"></i>
              </button>
            </div>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ filteredRecords.length }} registros</span>
      </div>
    </div>

    <!-- Modal editar -->
    <b-modal
      id="modal-error"
      modal-class="modal-as"
      centered
      hide-header
      hide-footer
      size="xl"
    >
      <div class="modal-inner">
        <div class="modal-hdr">
          <div class="modal-hdr__icon"><i class="fa-solid fa-pen"></i></div>
          <h4 class="modal-hdr__title">Editar registro</h4>
          <p class="modal-hdr__sub">{{ titleEdit }}</p>
        </div>

        <div class="modal-body-custom">
          <div class="form-grid form-grid--3">
            <div class="field field--span2">
              <label class="field__label">Titulo Amazon</label>
              <b-form-input size="sm" v-model="updateForm.tituloAmazon" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">Variacion Color</label>
              <b-form-input size="sm" v-model="updateForm.variacionColorAmazon" class="field__input" />
            </div>
          </div>
          <div class="form-grid" style="margin-top: 12px;">
            <div class="field">
              <label class="field__label">SKU Amazon</label>
              <b-form-input size="sm" v-model="updateForm.skuAmazon" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">EAN Amazon</label>
              <b-form-input size="sm" v-model="updateForm.eanAmazon" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">SKU Shopify</label>
              <b-form-input size="sm" v-model="updateForm.skuShopify" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">EAN Shopify</label>
              <b-form-input size="sm" v-model="updateForm.eanShopify" class="field__input" />
            </div>
          </div>
          <div class="form-grid form-grid--3" style="margin-top: 12px;">
            <div class="field field--span2">
              <label class="field__label">Errores</label>
              <b-form-input size="sm" v-model="updateForm.errores" class="field__input" />
            </div>
            <div class="field">
              <label class="field__label">Estado</label>
              <v-select
                v-model="updateForm.estado"
                :options="[{label: 'Pendiente', value: 0}, {label: 'Correcto', value: 1}, {label: 'Error', value: 2}]"
                :reduce="opt => opt.value"
                class="select-styled"
              />
            </div>
          </div>
        </div>

        <div class="modal-ftr">
          <button class="btn-modal btn-modal--ghost" @click="$bvModal.hide('modal-error')">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="saveEditLine()">
            <i class="fa-solid fa-check"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import BCardCode from "@core/components/b-card-code";
import { BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BTable, BFormFile } from "bootstrap-vue";
import * as XLSX from 'xlsx';
import vSelect from 'vue-select'

export default {
  components: { BCardCode, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BTable, BFormFile, vSelect },
  data() {
    return {
      updateForm: { id: 0, skuAmazon: "", eanAmazon: "", skuShopify: "", eanShopify: "", tituloAmazon: "", variacionColorAmazon: "", variacionTallaAmazon: "", errores: "", estado: 0, prioridad: 0 },
      records: [],
      columns: [
        { key: "estado", label: "", thStyle: { width: "40px" } },
        { key: "skuAmazon", label: "SKU Amazon", sortable: true },
        { key: "skuShopify", label: "SKU Shopify", sortable: true },
        { key: "tituloAmazon", label: "Titulo Amazon", sortable: true },
        { key: "tituloShopify", label: "Titulo Shopify", sortable: true },
        { key: "acciones", label: "", thStyle: { width: "110px" } },
      ],
      csvSkuAmazon: [],
      titleEdit: '',
      searchTerm: "",
      lastColor: "",
      mostrarTipo: "Todos"
    };
  },
  computed: {
    filteredRecords() {
      let results = this.records;
      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        results = results.filter(item =>
          (item.skuAmazon && item.skuAmazon.toLowerCase().includes(term)) ||
          (item.eanAmazon && item.eanAmazon.toLowerCase().includes(term)) ||
          (item.skuShopify && item.skuShopify.toLowerCase().includes(term)) ||
          (item.eanShopify && item.eanShopify.toLowerCase().includes(term))
        );
      }
      if (this.mostrarTipo !== "Todos") {
        const estadoMap = { "Pendientes": 0, "Correctos": 1, "Error": 2 };
        results = results.filter(item => item.estado === estadoMap[this.mostrarTipo]);
      }
      return results;
    },
    countPendientes() { return this.records.filter(r => r.estado === 0).length; },
    countCorrectos() { return this.records.filter(r => r.estado === 1).length; },
    countErrores() { return this.records.filter(r => r.estado === 2).length; },
  },
  methods: {
    loadItems() {
      Promise.all([axios.get("/amazon-shopify"), axios.get("/shopify/products")])
        .then(([resAmazon, resShopify]) => {
          this.records = resAmazon.data;
          this.combinarDatos(resAmazon.data, resShopify.data);
        }).catch(error => { console.error("Error al cargar:", error); });
    },
    combinarDatos(amazonData, shopifyData) {
      const shopifyMap = new Map();
      shopifyData.forEach(product => {
        product.variants.forEach(variant => {
          if (variant.sku) shopifyMap.set(variant.sku.trim(), { skuShopify: variant.sku.trim(), eanShopify: variant.barcode ? variant.barcode.trim() : '', tituloShopify: product.title ? product.title.trim() : '' });
        });
      });
      this.records = amazonData.map(item => {
        const shopifyInfo = shopifyMap.get(item.skuShopify.trim());
        return shopifyInfo ? { ...item, tituloShopify: shopifyInfo.tituloShopify } : item;
      });
    },
    procesarArchivo() {
      if (!this.csvSkuAmazon) return;
      const fileName = this.csvSkuAmazon.name.toLowerCase();
      if (fileName.endsWith('.json')) this.subirJson();
      else this.subirCsvAmazon();
    },
    subirImagenesJson() {
      if (!this.csvSkuAmazon) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const jsonData = JSON.parse(e.target.result);
        axios.put("/amazon-shopify/imagenes", jsonData).then(r => r.data).then(res => {
          this.$bvToast.toast(res.msg, { title: 'Imagenes actualizadas', variant: 'success', solid: true });
          this.loadItems();
        }).catch(error => { this.$bvToast.toast('Error al subir', { title: 'Error', variant: 'danger', solid: true }); });
      };
      reader.readAsText(this.csvSkuAmazon);
    },
    subirJson() {
      const reader = new FileReader();
      reader.onload = (e) => {
        const jsonData = JSON.parse(e.target.result);
        const datosParseados = jsonData.map(item => ({
          tituloAmazon: item.tituloAmazon || '', variacionColorAmazon: item.variacionColorAmazon || '', variacionTallaAmazon: item.variacionTallaAmazon || '',
          skuAmazon: item.skuAmazon || '', eanAmazon: item.eanAmazon || '', skuShopify: item.skuShopify || '', eanShopify: item.eanShopify || '',
          imagenAmazon: item.imagenAmazon || '', estado: item.mapeado === 'si' ? 1 : 0, errores: '', prioridad: 0
        }));
        axios.post("/amazon-shopify/multiple", datosParseados).then(r => r.data).then(res => {
          this.$bvToast.toast('JSON subido correctamente', { title: 'Match subido', variant: 'success', solid: true });
          this.loadItems();
        }).catch(error => { this.$bvToast.toast('Error al subir', { title: 'Error', variant: 'danger', solid: true }); });
      };
      reader.readAsText(this.csvSkuAmazon);
    },
    subirCsvAmazon() {
      var reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        const datosParseados = this.parseAmazonDatos(jsonData);
        datosParseados.shift();
        axios.post("/amazon-shopify/multiple", datosParseados).then(r => r.data).then(res => {
          this.$bvToast.toast('CSV subido correctamente', { title: 'Match subido', variant: 'success', solid: true });
        });
      };
      reader.readAsArrayBuffer(this.csvSkuAmazon);
    },
    parseAmazonDatos(datos) {
      return datos.map(row => {
        const newItem = {
          tituloAmazon: row['__EMPTY_6']?.toString().trim() || '', variacionColorAmazon: row['__EMPTY']?.toString().trim() || '',
          variacionTallaAmazon: row['__EMPTY_1']?.toString().trim() || '', skuAmazon: row['__EMPTY_2']?.toString().trim() || '',
          eanAmazon: row['__EMPTY_3']?.toString().trim() || '', skuShopify: row['__EMPTY_4']?.toString().trim() || '',
          eanShopify: row['__EMPTY_5']?.toString().trim() || '', estado: 0, errores: '', prioridad: 0
        };
        if (newItem.variacionColorAmazon != this.lastColor && newItem.variacionColorAmazon != "") this.lastColor = newItem.variacionColorAmazon;
        else if (newItem.variacionColorAmazon == "") newItem.variacionColorAmazon = this.lastColor;
        if (!newItem.skuAmazon && !newItem.eanAmazon) return null;
        return newItem;
      }).filter(Boolean);
    },
    editLine(item) {
      this.updateForm = JSON.parse(JSON.stringify(item));
      this.titleEdit = item.skuAmazon;
      this.$bvModal.show('modal-error');
    },
    saveEditLine() {
      this.$bvModal.hide('modal-error');
      const item = this.records.find(item => item.id === this.updateForm.id);
      if (item) {
        Object.assign(item, JSON.parse(JSON.stringify(this.updateForm)));
        axios.put("/amazon-shopify", item).then(r => r.data).then(res => {
          this.$bvToast.toast('Actualizado correctamente', { title: 'Guardado', variant: 'success', solid: true })
        }).catch(error => {
          this.$bvToast.toast('Error al guardar', { title: 'Error', variant: 'danger', solid: true })
        });
      }
    },
    changueEstado(item, estado) {
      item.estado = estado;
      axios.put("/amazon-shopify", item).then(r => r.data).then(res => {
        this.$bvToast.toast('Estado actualizado', { title: 'Guardado', variant: 'success', solid: true })
      }).catch(error => {
        this.$bvToast.toast('Error al guardar', { title: 'Error', variant: 'danger', solid: true })
      });
    },
    rowClass(item) {
      if (!item) return '';
      switch (item.estado) { case 1: return 'row-ok'; case 2: return 'row-error'; default: return 'row-pending'; }
    },
  },
  mounted() { this.loadItems(); },
};
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.amzshop-page { max-width: 1300px; margin: 0 auto; padding: 0 8px; }

.as-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 20px; }
.header-eyebrow { display: block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: #FF9900; margin-bottom: 2px; }
.header-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 700; color: $text; margin: 0; }

.btn-as {
  display: inline-flex; align-items: center; gap: 8px; padding: 9px 20px; border-radius: $radius-sm; border: none;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; white-space: nowrap;
  &--primary { background: $primary; color: white; &:hover { background: $primary-dark; } }
  &--warning { background: $warning; color: white; &:hover { background: darken($warning, 8%); } }
}

// KPI
.kpi-strip { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 20px; }
.kpi-card { background: $card-bg; border: 1px solid $border; border-radius: $radius-sm; padding: 16px 18px; display: flex; flex-direction: column; box-shadow: $shadow; }
.kpi-label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; }
.kpi-value { font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 700; color: $text; font-feature-settings: "tnum"; margin: 4px 0 2px; &--warning { color: $warning; } &--green { color: $success; } &--danger { color: $danger; } }
.kpi-foot { font-family: 'JetBrains Mono', monospace; font-size: 10px; color: $text-muted; }

// Section card
.section-card {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden; margin-bottom: 16px;
  &__header { display: flex; justify-content: space-between; align-items: center; padding: 16px 22px; border-bottom: 1px solid $border; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 700; color: $text; margin: 0; display: flex; align-items: center; gap: 8px; }
}

.upload-row { display: flex; align-items: center; gap: 12px; padding: 16px 22px; }

// List card
.list-card {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden;
  &__header { padding: 18px 22px; border-bottom: 1px solid $border; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: $text; margin: 0 0 12px; }
  &__filters { display: flex; justify-content: space-between; align-items: center; gap: 14px; }
  &__footer { padding: 12px 22px; border-top: 1px solid $border; }
}

.filter-pills { display: flex; gap: 4px; }
.pill {
  padding: 5px 12px; border-radius: 20px; border: 1px solid $border; background: transparent;
  font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 500; color: $text-muted; cursor: pointer; transition: all 0.15s ease;
  &:hover { border-color: $primary; color: $primary; }
  &.active { background: $primary; border-color: $primary; color: white; }
  &--warning.active { background: $warning; border-color: $warning; }
  &--green.active { background: $success; border-color: $success; }
  &--danger.active { background: $danger; border-color: $danger; }
}

.search-box {
  position: relative; width: 240px;
  &__icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: $text-muted; font-size: 12px; }
  &__input { width: 100%; padding: 7px 12px 7px 32px; border: 1px solid $border; border-radius: $radius-sm; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; color: $text; background: transparent; &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; } }
}

// Table
.table-wrapper { padding: 0; }
// Los ::v-deep van bajo .amzshop-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.amzshop-page ::v-deep .table-head th { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: $text-muted; border-top: none; border-bottom: 1px solid $border; padding: 10px 16px; background: transparent; }
.amzshop-page ::v-deep .row-ok td { background: rgba($success, 0.04); }
.amzshop-page ::v-deep .row-error td { background: rgba($danger, 0.04); }
.amzshop-page ::v-deep .row-pending td { background: transparent; }
.amzshop-page ::v-deep .row-ok td, .amzshop-page ::v-deep .row-error td, .amzshop-page ::v-deep .row-pending td { padding: 10px 16px; vertical-align: middle; border-color: lighten($border, 3%); font-size: 13px; }
.amzshop-page ::v-deep .row-ok:hover td { background: rgba($success, 0.08); }
.amzshop-page ::v-deep .row-error:hover td { background: rgba($danger, 0.08); }
.amzshop-page ::v-deep .row-pending:hover td { background: $bg; }

.cell-sku { font-family: 'JetBrains Mono', monospace; font-size: 12px; font-weight: 500; color: $text; &--accent { color: $primary; font-weight: 600; } }
.cell-text { font-size: 13px; color: $text; }
.cell-muted { color: #CBD5E1; font-size: 12px; }

.estado-badge {
  display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; border-radius: 50%; font-size: 11px;
  &--ok { background: rgba($success, 0.12); color: $success; }
  &--error { background: rgba($danger, 0.12); color: $danger; }
  &--pending { background: rgba($warning, 0.12); color: $warning; }
}

.cell-actions { display: flex; gap: 4px; }
.action-btn {
  width: 30px; height: 30px; border-radius: 6px; border: 1px solid transparent; background: transparent; color: $text-muted; cursor: pointer;
  display: flex; align-items: center; justify-content: center; transition: all 0.15s ease; font-size: 12px;
  &--edit:hover { background: rgba($primary, 0.1); color: $primary; border-color: rgba($primary, 0.2); }
  &--ok:hover { background: rgba($success, 0.1); color: $success; border-color: rgba($success, 0.2); }
  &--error:hover { background: rgba($danger, 0.1); color: $danger; border-color: rgba($danger, 0.2); }
}

.footer-count { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $text-muted; }

// Responsive
@media (max-width: 768px) {
  .kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .list-card__filters { flex-direction: column; align-items: flex-start; }
  .search-box { width: 100%; }
  .upload-row { flex-direction: column; }
}
</style>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

// Modal
.modal-as {
  .modal-content { border-radius: 16px; border: 1px solid #E2E8F0; box-shadow: 0 20px 60px rgba(0,0,0,0.12), 0 8px 20px rgba(0,0,0,0.06); overflow: hidden; }
  .modal-body { padding: 0; }
}

.modal-inner { padding: 0; }
.modal-hdr {
  text-align: center; padding: 28px 28px 0;
  &__icon { width: 48px; height: 48px; border-radius: 12px; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 14px; font-size: 18px; background: rgba(#3B82F6, 0.1); color: #3B82F6; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 18px; font-weight: 700; color: #1E293B; margin: 0 0 4px; }
  &__sub { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: #64748B; margin: 0; }
}
.modal-body-custom { padding: 22px 28px; }
.modal-ftr { display: flex; justify-content: flex-end; gap: 8px; padding: 0 28px 24px; }

.form-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; &--3 { grid-template-columns: repeat(3, 1fr); } }
.field {
  display: flex; flex-direction: column; gap: 5px;
  &--span2 { grid-column: span 2; }
  &__label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 0.5px; text-transform: uppercase; color: #64748B; margin: 0; }
  &__input { border-radius: 8px !important; border: 1px solid #E2E8F0 !important; font-size: 13px !important; &:focus { border-color: #3B82F6 !important; box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1) !important; } }
}

.amzshop-page .select-styled {
  .vs__dropdown-toggle { min-height: 31px; border-radius: 8px; border: 1px solid #E2E8F0; }
  .vs__search { font-size: 13px; }
}

.btn-modal {
  display: inline-flex; align-items: center; gap: 6px; padding: 9px 18px; border-radius: 8px; border: none;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s ease;
  &--primary { background: #3B82F6; color: white; &:hover { background: #2563EB; } }
  &--ghost { background: transparent; color: #64748B; &:hover { background: #F1F5F9; color: #1E293B; } }
}

// Dark mode
.dark-layout {
  .amzshop-page {
    .header-title { color: #E2E8F0; }
    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }
    .section-card { background: #1E293B; border-color: #334155; }
    .section-card__header { border-color: #334155; }
    .section-card__title { color: #E2E8F0; }
    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }
    .search-box__input { border-color: #334155; color: #E2E8F0; &::placeholder { color: #475569; } &:focus { border-color: #3B82F6; } }
    .pill { border-color: #475569; color: #94A3B8; &:hover { border-color: #3B82F6; color: #3B82F6; } &.active { color: white; } }
    .table-head th { color: #94A3B8; border-color: #334155; }
    .row-ok td { background: rgba(#10B981, 0.06); }
    .row-error td { background: rgba(#EF4444, 0.06); }
    .row-pending td { background: transparent; }
    .row-ok td, .row-error td, .row-pending td { border-color: #334155; }
    .row-ok:hover td { background: rgba(#10B981, 0.1); }
    .row-error:hover td { background: rgba(#EF4444, 0.1); }
    .row-pending:hover td { background: rgba(255,255,255,0.03); }
    .cell-sku { color: #E2E8F0; }
    .cell-text { color: #E2E8F0; }
    .action-btn { color: #94A3B8; }
  }
  .modal-as .modal-content { background: #1E293B; border-color: #334155; }
  .modal-hdr__title { color: #E2E8F0; }
  .field__label { color: #94A3B8; }
  .field__input { background: #0F172A !important; border-color: #334155 !important; color: #E2E8F0 !important; }
  .btn-modal--ghost { color: #94A3B8; &:hover { background: rgba(255,255,255,0.05); color: #E2E8F0; } }
}
</style>
